import { Dialog } from '@headlessui/react'
import { TdsDatetime } from '@scania/tegel-react'
import styled from 'styled-components'

export const Overlay = styled.div.attrs({
  className: 'tds-modal-backdrop'
})``

export const Panel = styled.div.attrs({
  className: 'tds-modal sdds-modal-sm'
})`
  display: flex;
  max-height: 100%;
`

export const FullWidthForm = styled.form`
  width: 100%;
`

export const Header = styled.div.attrs({ className: 'tds-modal-header' })``

export const Container = styled.div`
  position: fixed;
  display: flex;

  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;

  align-items: center;

  justify-content: center;

  z-index: 40000;
`

export const ModalHeadline = styled(Dialog.Title).attrs({
  className: 'tds-modal-headline'
})`
  text-transform: capitalize;
`

export const ModalBody = styled.div.attrs({
  className: 'tds-modal-body sdds-on-white-bg'
})``

export const FormRow = styled.div.attrs({
  className: 'tds-u-mt3'
})``

export const DateRow = styled.div.attrs({
  className: 'tds-row'
})``

export const StyledDateTime = styled(TdsDatetime).attrs({
  className: 'tds-col-xs-12 tds-col-md-6 tds-u-mt3'
})`
  @media (max-width: ${({ theme }) => theme.size.md}) {
    padding: 0;
  }

  @media (min-width: ${({ theme }) => theme.size.md}) {
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
  }
`

export const ModalActions = styled.div.attrs({
  className: 'tds-modal-actions sdds-u-pb1'
})``
